// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"b85a6c1b","847":"6bbaed90"}[chunkId] + ".chunk.css";
};